import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import cn from 'classnames';
import style from "../common.module.scss"
import CloseIcon from '../../../shared/icons/CloseIcon';
import EditIconNew from '../../../shared/icons/EditIconNew';
import PlusIcon from '../../../shared/icons/PlusIcon';
import MoreIcon from '../../../shared/icons/MoreIcon';
import { ORDER_STATUSES_DATA } from '../../../../mock';
import BallIcon from '../../../shared/icons/BallIcon';
import CancelApp from '../../../order/info/CancelApp';
import OrdersDelete from '../../../order/info/OrdersDelete';
import { File, Aviation } from '../../../../services';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useScreenSize } from '../../../../hooks/useScreenSize';
import CopyIconNew from '../../../shared/icons/CopyIconNew';
import { AlarmClockPlusIcon, FileDigitIcon, FileDownIcon, ShareIcon, Trash2Icon, Undo2Icon } from 'lucide-react';
import ExtendTenderEndDate from '../../../orders-new/order-info/components/ExtendTenderEndDate/ExtendTenderEndDate';
import SendToMarketplaceModal from '../../../orders-new/order-info/components/SendToMarketplaceModal';
import AppTooltip from '../../../shared/AppTooltip/AppTooltip';
import AddProjectNumberModal from '../../../orders-new/order-info/components/AddProjectNumberModal/AddProjectNumberModal';

const OrdersInfoHeader = ({ item, setIsOpen, onForceUpdate, isShowMore = true }) => {
    const { t } = useTranslation();
    const { user } = useSelector((state) => state);
    const { isTabletSmallView } = useScreenSize();
    const navigate = useNavigate();
    const moreRef = useRef(null);

    const [isOpenDropdowns, setIsOpenDropdowns] = useState(false);
    const [isCancel, setCancelModal] = useState(false);
    const [isDelete, setDelete] = useState(false);
    const [infoModal, setInfoModal] = useState(false);
    const [copyModal, setCopyModal] = useState(false);
    const [showExtendTenderModal, setShowExtendTenderModal] = useState(false);
    const [showConfirmMarketplaceModal, setShowConfirmMarketplaceModal] = useState(false);
    const [showAddProjectNumberModal, setShowAddProjectNumberModal] = useState(false);

    const shouldShowButton = () => {
      return (
        item?.status === "awaitingoffer" ||
        item?.status === "moderation" ||
        item?.status === "awaiting_payment" ||
        String(item?.status || "").toLowerCase() === "expeditorrejected" ||
        item?.status === "canceled"
      );
    };

    const handleDownloadClick = () => {
        setIsOpenDropdowns(false)
    };

    const handleClickOutside = (event) => {
        if (moreRef.current && !moreRef.current.contains(event.target)) {
            setIsOpenDropdowns(false);
        }
    };

    const downloadInvoice = async (orderId) => {
        toast.success(t('orderInfo.ordersInfoHeader.copySuccess')); // Reusing key
        try {
          const response = await File.getDocPayment(orderId);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${item.number}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } catch (error) {
          console.error('Ошибка загрузки платежного документа:', error);
        }
    };

    const downloadOrderPdf = async () => {
        try {
            const response = await File.getAirOrderPdf(item.id);
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `order_${item.number}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Ошибка выгрузки PDF заказа:', error);
            toast.error('Не удалось выгрузить PDF заказа');
        }
        setIsOpenDropdowns(false);
    };

    useEffect(() => {
        if (isOpenDropdowns) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpenDropdowns]);

    return (
        <div className={style.header_wrapper}>
            <CloseIcon
                fill="#6D7885"
                width="24"
                height="24"
                onClick={() => {
                if (setIsOpen) {
                    setIsOpen(false);
                } else {
                    navigate(-1);
                }
                }}
                style={{ cursor: "pointer" }}
            />
            <div className={style.header_text}>
                <div className={style.orders_title}>{item?.cityFromName} - {item?.cityToName}</div>
                <div className={style.orders_status} style={{ color: ORDER_STATUSES_DATA(t)[item?.status]?.color }}>
                    <BallIcon fill={ORDER_STATUSES_DATA(t)[item?.status]?.color} />
                    {ORDER_STATUSES_DATA(t)[item?.status]?.title || item?.status}
                </div>
            </div>
            {shouldShowButton() && user?.companyId === item.companyId &&(
                <>
                  <EditIconNew
                    style={{ cursor: 'pointer' }}
                    data-tooltip-id="avia-info-edit-tooltip"
                    onClick={() => navigate(`/aviation/edit/${item.id}`)}
                  />
                  <AppTooltip id="avia-info-edit-tooltip" place="bottom" positionStrategy="fixed">
                    {t('tooltips.editOrder')}
                  </AppTooltip>
                </>
            )}
            {user.type === "Client" &&
                user?.companyId === item?.companyId &&
                (isTabletSmallView ? (
                <CopyIconNew title="copy" onClick={() => navigate(`/aviation/copy/${item.id}`)} />
                ) : (
                <button className={style.header_btn} onClick={() => navigate(`/aviation/copy/${item.id}`)}>
                    <PlusIcon /> {t("orderInfo.ordersInfoHeader.copyButton")}
                </button>
                ))}
            {user.type === "Client" && (
                <div className={style.header_more} ref={moreRef}>
                    <MoreIcon
                      data-tooltip-id="avia-info-more-tooltip"
                      onClick={() => { setIsOpenDropdowns(!isOpenDropdowns)}}
                    />
                    <AppTooltip id="avia-info-more-tooltip" place="bottom" positionStrategy="fixed">
                      {t('tooltips.additionalMenu')}
                    </AppTooltip>
                    <div className={cn(style.header_dropdowns, { [style.header_dropdowns_open]: isOpenDropdowns })}>
                        {/* <div className={style.header_dropdowns_item} onClick={handleDownloadClick}>Отправить в черновик</div> */}
                        {/* <div className={cn(style.header_dropdowns_item)} onClick={() => downloadInvoice(item.id)}>Скачать счет на оплату</div> */}

                        {user?.companyId === item?.companyId && item?.status === "awaitingoffer" && item?.tenderDateEnd && (
                            <div
                                className={style.header_dropdowns_item}
                                onClick={() => {
                                    setShowExtendTenderModal(true);
                                    setIsOpenDropdowns(false);
                                }}
                            >
                                <AlarmClockPlusIcon size={18} color="#6D7885" />
                                {t("orderInfo.ordersInfoHeader.extendTenderAction")}
                            </div>
                        )}
                        {user?.companyId === item?.companyId && (
                            <div
                                className={style.header_dropdowns_item}
                                onClick={downloadOrderPdf}
                                style={{ cursor: "pointer" }}
                            >
                                <FileDownIcon size={18} color="#6D7885" />
                                {t("orderInfo.ordersInfoHeader.generateOrderPdf")}
                            </div>
                        )}
                        {user?.companyId === item?.companyId && (
                            <div
                                className={style.header_dropdowns_item}
                                onClick={() => {
                                    setShowAddProjectNumberModal(true);
                                    setIsOpenDropdowns(false);
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <FileDigitIcon size={18} color="#6D7885" />
                                {t("orderInfo.ordersInfoHeader.addProjectNumber")}
                            </div>
                        )}
                        {(shouldShowButton() || item?.status === "confirmed") && user?.companyId === item.companyId && item?.status !== "canceled" && (
                            <div className={cn(style.header_dropdowns_item, style.header_dropdowns_reset)} onClick={() => setCancelModal(true)}><Undo2Icon size={18} color="#E53935" /> {t('orderInfo.ordersInfoHeader.withdrawOrderButton')}</div>
                        )}
                        {(shouldShowButton() || item?.status === "confirmed") && user?.companyId === item.companyId && (
                            <div className={cn(style.header_dropdowns_item, style.header_dropdowns_reset)} onClick={() => setDelete(true)}><Trash2Icon size={18} color="#E53935" /> {t('orderInfo.ordersInfoHeader.deleteOrderButton')}</div>
                        )}
                </div>
                </div>
            )}
            {isCancel &&
                <CancelApp
                    item={item}
                    onClose={() => setCancelModal(false)}
                    onUpdateData={() => onForceUpdate()}
                    isAirOrder
                />
            }
            {isDelete &&
                <OrdersDelete
                    item={item}
                    onClose={() => setDelete(false)}
                    onUpdateData={() => {
                        if (setIsOpen) {
                             onForceUpdate();
                        } else {
                            navigate(-1);
                        }
                    }}
                    isAirOrder
                />
            }

            <SendToMarketplaceModal
                isOpen={showConfirmMarketplaceModal}
                orderId={item ? item.id : ""}
                tenderDateEnd={item?.tenderDateEnd}
                onSuccess={() => {
                    setShowConfirmMarketplaceModal(false);
                    if (onForceUpdate) {
                        onForceUpdate();
                    }
                }}
                onCancel={() => setShowConfirmMarketplaceModal(false)}
                isAvia
            />

            <ExtendTenderEndDate
                isOpen={showExtendTenderModal}
                orderId={item ? item.id : ""}
                tenderDateEnd={item?.tenderDateEnd}
                onSuccess={() => {
                    setShowExtendTenderModal(false);
                    if (onForceUpdate) {
                        onForceUpdate();
                    }
                }}
                onCancel={() => setShowExtendTenderModal(false)}
                isAvia
            />

            <AddProjectNumberModal
                isOpen={showAddProjectNumberModal}
                orderId={item?.id}
                onSubmit={(orderId, ref) =>
                    Aviation.updateReferenceNumber(orderId, ref)
                }
                onSuccess={() => {
                    setShowAddProjectNumberModal(false);
                    if (onForceUpdate) {
                        onForceUpdate();
                    }
                }}
                onCancel={() => setShowAddProjectNumberModal(false)}
            />
        </div>
    );
};

export default OrdersInfoHeader;
